// 通用翻译 - 跨域共用的按钮 / 状态 / 提示词（域词条见各域文件；死键审计与拆分记录见 BACKLOG）

export const zh = {
  error: '错误',
  save: '保存',
  cancel: '取消',
  delete: '删除',
  edit: '编辑',
  confirmDelete: '确认',
  totalItems: '项内容',
  noMatchingHistory: '未找到匹配的历史记录',
  tryOtherKeywords: '尝试其他关键词',
  logout: '退出登录',
  confirmLogoutTitle: '确认退出登录',
  download: '下载',
  copyFailed: '复制失败',
  confirmLogoutDesc: '退出后需要重新验证才能继续使用。',
  confirmDeleteTitle: '确认删除',
  confirmDeleteThread: '删除会话',
  deleteThreadWarning: '会话及其消息、运行记录将一并删除，此操作不可恢复。',
  sessionDeleted: '会话已删除',
  confirmDeleteDescription: '此操作无法撤销，请确认是否继续？',
  deleting: '删除中...',
  saving: '保存中...',
  success: '成功',
  failed: '失败',
  loadFailed: '加载失败',
  deleteFailed: '删除失败',
  loading: '加载中...',
  serverErrorTitle: '服务端错误',
  serverErrorFallback: '请求处理失败，请重试',
  retryAction: '重试',
  image: '图片',
  attachment: '附件',
  artifactChartGenerating: '图表生成中...',
  artifactMermaidGenerating: '流程图生成中...',
  artifactDataError: '图表数据格式错误',
  artifactHtmlTruncated: 'HTML 生成不完整（输出可能被截断），预览可能为空白。可在代码视图中查看已生成部分，或重新生成。',
  videoLoading: '加载视频中...',
  videoLoadFailed: '视频加载失败',
  imageLoading: '加载图片中...',
  imageLoadFailed: '图片加载失败',
  mediaLinkInvalid: '无法识别有效的媒体链接',
  artifactSchemaHintPlaceholder: '产出物应包含：\n# 标题\n- 要点1\n- 要点2',
  mediaFile: '媒体文件',
  noData: '暂无数据',
  availableTools: '可用工具',
  noToolsAvailable: '暂无可用工具',
  uploadImageFile: '请上传图片文件',
  imageSizeExceeded: '图片大小不能超过 2MB',
  imageProcessFailed: '图片处理失败，请重试',
  saveFailedLater: '保存失败，请稍后重试',
}

export const en = {
  error: 'Error',
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  edit: 'Edit',
  confirmDelete: 'Are you sure you want to delete this conversation?',
  totalItems: 'total items',
  noMatchingHistory: 'No matching history found',
  tryOtherKeywords: 'Try other keywords',
  logout: 'Logout',
  confirmLogoutTitle: 'Confirm logout',
  confirmLogoutDesc: 'You will need to sign in again to continue.',
  confirmDeleteTitle: 'Confirm Delete',
  confirmDeleteThread: 'Delete conversation',
  deleteThreadWarning: 'Conversation, its messages and runs will be deleted. This cannot be undone.',
  sessionDeleted: 'Conversation deleted',
  download: 'Download',
  copyFailed: 'Copy failed',
  confirmDeleteDescription: 'This action cannot be undone. Are you sure you want to continue?',
  deleting: 'Deleting...',
  saving: 'Saving...',
  success: 'Success',
  failed: 'Failed',
  loadFailed: 'Load failed',
  deleteFailed: 'Delete failed',
  loading: 'Loading...',
  serverErrorTitle: 'Server error',
  serverErrorFallback: 'Request failed, please try again',
  retryAction: 'Retry',
  image: 'Image',
  attachment: 'Attachment',
  artifactChartGenerating: 'Generating chart...',
  artifactMermaidGenerating: 'Generating diagram...',
  artifactDataError: 'Invalid chart data format',
  artifactHtmlTruncated: 'HTML is incomplete (output may have been truncated); the preview may appear blank. Check the generated portion in code view or regenerate.',
  videoLoading: 'Loading video...',
  videoLoadFailed: 'Video failed to load',
  imageLoading: 'Loading image...',
  imageLoadFailed: 'Image failed to load',
  mediaLinkInvalid: 'Cannot recognize a valid media link',
  artifactSchemaHintPlaceholder: 'Artifact should contain:\n# Title\n- Point 1\n- Point 2',
  mediaFile: 'Media File',
  noData: 'No data',
  availableTools: 'Available Tools',
  noToolsAvailable: 'No tools available',
  uploadImageFile: 'Please upload an image file',
  imageSizeExceeded: 'Image size cannot exceed 2MB',
  imageProcessFailed: 'Image processing failed, please try again',
  saveFailedLater: 'Save failed, please try again later',
}

export const ja = {
  error: 'エラー',
  save: '保存',
  cancel: 'キャンセル',
  delete: '削除',
  edit: '編集',
  confirmDelete: 'この会話を削除してもよろしいですか？',
  totalItems: '件のアイテム',
  noMatchingHistory: '一致する履歴が見つかりません',
  tryOtherKeywords: '他のキーワードを試してください',
  logout: 'ログアウト',
  confirmLogoutTitle: 'ログアウトの確認',
  confirmLogoutDesc: '続行するには再度サインインが必要です。',
  confirmDeleteTitle: '削除の確認',
  confirmDeleteThread: '会話を削除',
  deleteThreadWarning: '会話とメッセージ・実行履歴はすべて削除されます。元に戻せません。',
  sessionDeleted: '会話を削除しました',
  download: 'ダウンロード',
  copyFailed: 'コピーに失敗しました',
  confirmDeleteDescription: 'この操作は取り消せません。続行しますか？',
  deleting: '削除中...',
  saving: '保存中...',
  success: '成功',
  failed: '失敗',
  loadFailed: '読み込みに失敗しました',
  deleteFailed: '削除に失敗しました',
  loading: '読み込み中...',
  serverErrorTitle: 'サーバーエラー',
  serverErrorFallback: 'リクエストが失敗しました。もう一度お試しください',
  retryAction: '再試行',
  image: '画像',
  attachment: '添付ファイル',
  artifactChartGenerating: 'チャート生成中...',
  artifactMermaidGenerating: 'ダイアグラム生成中...',
  artifactDataError: 'チャートデータの形式が正しくありません',
  artifactHtmlTruncated: 'HTML が不完全です（出力が途切れた可能性があります）。プレビューが空白になる場合があります。コードビューで生成済み部分を確認するか、再生成してください。',
  videoLoading: '動画を読み込み中...',
  videoLoadFailed: '動画の読み込みに失敗しました',
  imageLoading: '画像を読み込み中...',
  imageLoadFailed: '画像の読み込みに失敗しました',
  mediaLinkInvalid: '有効なメディアリンクを認識できません',
  artifactSchemaHintPlaceholder: '成果物に含める内容：\n# タイトル\n- ポイント1\n- ポイント2',
  mediaFile: 'メディアファイル',
  noData: 'データがありません',
  availableTools: '利用可能なツール',
  noToolsAvailable: '利用可能なツールがありません',
  uploadImageFile: '画像ファイルをアップロードしてください',
  imageSizeExceeded: '画像サイズは2MBを超えることはできません',
  imageProcessFailed: '画像の処理に失敗しました。もう一度お試しください',
  saveFailedLater: '保存に失敗しました。後でもう一度お試しください',
}
